
import React,{useState} from "react";
import WarningAlert from '../../../utils/WarningAlert';
import { toast } from 'react-toastify';
import Update from "./Update";
import {useDeleteQualificationMutation} from "../../../Services/api";
export default function Delete(props) {
    const notify = () => '';
    const [deleteQualification] = useDeleteQualificationMutation();
    const handleDelete = async (index,e) => {
        const values={id:index}
        var confirm = await WarningAlert();
        if(confirm===true){
            deleteQualification({ data: values }).unwrap()
            .then((payload) => {
                if (payload.status) {
                    toast.success(payload.message)
                }else{
                    toast.error(payload.message)
                }
            }).catch((error) => {
                toast.error(error.data.message)
            });
            notify();
        }   
    }
    const [qualificationId,setQualificationId] = useState("");
    return (<>
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
            <div className="btn-group" role="group">
                <button id="btnGroupDrop1" type="button" className="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Action
                </button>
                <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                
                <button className="dropdown-item"  data-bs-toggle="modal" onClick={()=>setQualificationId(props.id)} data-id={props.id} data-bs-target="#fullscreenModal" >
                    <div className="icon text-info">
                    <i className="bi bi-pencil-square"></i>
                        Update
                    </div>
                </button>
                <button className="dropdown-item"
                    onClick={e => handleDelete(props.id,e)}>
                    <div className="icon text-danger">
                    <i className="bi bi-trash"></i>
                        Delete
                    </div>
                </button>
                </div>
            </div>
        </div>
        <Update id={qualificationId}/>
    </>)
}